import { Avatar } from './core';
import { FramedAvatar } from './framed';
export { Avatar, FramedAvatar };
export default Avatar;